<template>
    <div class="question-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>常见问题</h1>
                <p class="English">FAQ</p>
            </div>
        </div>
        <div class="container">
            <!-- <ul class="type-list">
                <li v-for="(item,index) in typeList" :key="index" class="vertical-middle select-point" :class="{active:item.value == activeIndex}">
                    {{item.label}}
                </li>
            </ul> -->
            <ul class="main-list">
                <li v-for="(item,index) in listData" :key="index" class="display-flex-between" :class="{active:mainIndex ===  index}" @click="mainIndex =  index">
                    <div class="left-part">
                        <p class="name">Q. {{item.title}}</p>
                        <div class="answer-wrap flex">
                            <span>A. </span>
                            <p class="answer-list">{{item.content}}</p>
                            <!-- <ul class="answer-list">
                                <li>
                                    (1)为保障产品的运输安全与运输时间，产品运输均使用顺丰速运；<br/>(2)来回运费需由用户支付，寄出时运费到付（默认保价），寄回时运费由用户承担； <br/>(3)因物流时效等快递方因素造成的损失，需客户自行承担相应风险； (4)因产品质量问题退换货，我司承担相应运费；<br/> (5)长租产品，满足相应产品包邮条件，则寄出包邮，寄回由用户承担。
                                </li>
                            </ul> -->
                        </div>
                    </div>
                    <img class="btn" src="~@assets/img/more-black.png" @click.stop="mainIndex = ''">
                </li>
            </ul>
            <!-- <div class="pages-wrap">
                <span v-for="(item,index) in 5" :key="index" class="item select-point" :class="{active:item == pagesIndex}">{{index + 1}}</span>
            </div> -->
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    export default {
		data() {
			return {
                activeIndex:0,
                pagesIndex:1,
                mainIndex:'',
                typeList:[
                    {
                        label:'租赁规则',value:0
                    },
                    // {
                    //     label:'租赁规则',value:1
                    // },
                    // {
                    //     label:'用户须知',value:2
                    // },
                ],  
                listData:[],
			}
        },
        created(){
            network(CONFIG.question,{type:2},{
                method:'POST'
            }).then(res => {
                this.listData = res.details.questions;
            });
        },
        methods:{
        }
    }
</script>

<style lang="scss">
    .question-page {
        padding-bottom: 80px;
        .public-banner{
            background-image:url('https://resource.tanwuapp.com/FjSf8Krt85XI0j5efBD4m6BjYZWb') ;
        }
        .main-list{
            border-top: 1px solid #EEEEEE;
            font-size: 14px;
            line-height: 1.4285;
            margin-bottom: 40px;
            margin-top: 40px;
            > li{
                padding: 29px 0;
                border-bottom: 1px solid #EEEEEE;
                cursor: pointer;
                .name{
                    font-size: 16px;
                    line-height: 1.375;
                    font-weight: bold;
                    transition: color 0.2s;
                }
                .btn{
                    margin-top: 4px;
                    width: 14px;
                    height: 14px;
                }
                .left-part,.btn{
                    transition: transform 0.3s;
                }
                .answer-wrap{
                    display: none;
                    padding-top: 10px;
                    line-height: 2.428;
                    .answer-list{
                        padding: 0 0 11px 6px;
                    }
                }
                &:not(.active):hover{
                    .left-part{
                        transform: translateX(20px);
                    }
                    .btn{
                        transform: translateX(-20px);
                    }
                    .name{
                        color: #3ED8C4;
                    }
                }
                &.active{
                    .name{
                        color: #3ED8C4;
                    }
                    .btn{
                        transform:rotate(45deg);
                    }
                    .answer-wrap{
                        display: flex;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/question.vue